const IMAGE_EXTENSIONS_BY_MIME_TYPE: Record<string, string> = {
    "image/avif": "avif",
    "image/bmp": "bmp",
    "image/gif": "gif",
    "image/heic": "heic",
    "image/heif": "heif",
    "image/jpeg": "jpg",
    "image/png": "png",
    "image/svg+xml": "svg",
    "image/tiff": "tiff",
    "image/webp": "webp",
};

function getFileName(value?: string | null): string {
    if (!value) {
        return "";
    }

    const withoutQuery = value.split(/[?#]/, 1)[0];
    const fileName = withoutQuery.split(/[\\/]/).pop()?.trim() || "";

    try {
        return decodeURIComponent(fileName);
    } catch (error) {
        return fileName;
    }
}

function hasExtension(fileName: string): boolean {
    return /\.[a-z0-9]{1,10}$/i.test(fileName);
}

export function getImageDownloadFileName(
    originalFileName: string | null | undefined,
    storedFileName: string,
    mimeType: string,
): string {
    const originalName = getFileName(originalFileName);
    const storedName = getFileName(storedFileName);
    const baseName = originalName || storedName || "imagem";

    if (hasExtension(baseName)) {
        return baseName;
    }

    const normalizedMimeType = mimeType.toLowerCase().split(";", 1)[0].trim();
    const extension = IMAGE_EXTENSIONS_BY_MIME_TYPE[normalizedMimeType];

    return extension ? `${baseName}.${extension}` : baseName;
}
